import { useState } from "react";
import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { inputCls } from "./fields";

export default function WaiverBlock({ text, agreed, signature, onAgree, onSign, idPrefix = "bk" }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div data-testid="waiver-block" className="space-y-4">
      <div className="relative">
        <div
          data-testid="waiver-text"
          data-lenis-prevent
          data-expanded={expanded ? "true" : "false"}
          className={`overflow-y-auto overscroll-contain whitespace-pre-line rounded-lg border border-lavender-700/10 bg-white p-5 pb-16 text-sm leading-relaxed text-stone-700 ${expanded ? "max-h-none" : "max-h-72"}`}
        >
          {text || "The grooming waiver will appear here."}
        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center rounded-b-lg bg-gradient-to-t from-white via-white/90 to-transparent px-4 pb-3 pt-8">
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            data-testid="waiver-expand-button"
            className="btn-secondary pointer-events-auto inline-flex items-center gap-2 px-4 py-2 text-xs font-semibold"
          >
            {expanded ? <ChevronsDownUp size={14} /> : <ChevronsUpDown size={14} />}
            {expanded ? "Collapse waiver" : "Expand to read the full waiver"}
          </button>
        </div>
      </div>
      <label className="flex items-start gap-3 text-sm text-stone-700">
        <input
          type="checkbox"
          required
          checked={agreed}
          onChange={(e) => onAgree(e.target.checked)}
          data-testid="waiver-agree-checkbox"
          className="mt-0.5 h-4 w-4 shrink-0 accent-lavender-700"
        />
        <span>I have read and agree to the grooming waiver above. *</span>
      </label>
      <div>
        <label className="text-sm font-medium text-stone-600" htmlFor={`${idPrefix}-signature`}>Type your full name to sign *</label>
        <input
          id={`${idPrefix}-signature`}
          required
          value={signature}
          onChange={(e) => onSign(e.target.value)}
          data-testid="waiver-signature-input"
          className={`${inputCls} mt-1.5 font-serif text-lg italic`}
          placeholder="Jane Doe"
          autoComplete="off"
        />
        <p className="mt-1.5 text-xs text-stone-500">Typing your name acts as your electronic signature and is dated when you submit.</p>
      </div>
    </div>
  );
}
